import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";

// 人脸识别
export const faceServe = {
  personVerify: data => Ajax.unsafePost("/fs-user-face-card", jsToFormData(data)),
  userSearch: data => Ajax.unsafePost("/fs-user-face-face", jsToFormData(data)),// 人脸搜索
  recognizeCard: (data, headers) => Ajax.unsafePost("/fs-user-card-phone", jsToFormData(data), headers),// 身份证识别
  postPhoto: (data, headers) => Ajax.unsafePost("/fs-post-photo", jsToFormData(data), headers),
  realChecks: data => Ajax.post("/fs-user-post-review-photo", jsToFormData(data)),// 真人审核
  uploadFile: (data, headers) => Ajax.unsafePost("/fs-user-card-phone", jsToFormData(data), { token: headers }),// 身份证上传图片
  getStudent: data => Ajax.get(`/fs-get-photo`, data,false),// 获取上传图片地址
};
